import React from 'react'
import { Text, View } from 'react-native'

import { searchableList } from './styles'
import type { OptionListProps } from './types'

const NoResults = ({
  labels,
  emptyOptions,
  renderOption,
}: Pick<OptionListProps, 'labels' | 'emptyOptions' | 'renderOption'>) => {
  const styles = searchableList()

  return (
    <View>
      <View className={styles.emptyContainer()}>
        <Text className={styles.emptyText()}>{labels.noResults}</Text>
      </View>
      {emptyOptions.map((option, index) => renderOption(option, index, emptyOptions))}
    </View>
  )
}

export default NoResults
